// extracted by mini-css-extract-plugin
export var activeYearPill = "storyCarousel-module--active-year-pill--bae02";
export var arrowButton = "storyCarousel-module--arrow-button--b4332";
export var card = "storyCarousel-module--card--8c1b7";
export var cardViewNextArrowButtonContainer = "storyCarousel-module--card-view-next-arrow-button-container--15a1a";
export var cardViewPreviousArrowButtonContainer = "storyCarousel-module--card-view-previous-arrow-button-container--8c168";
export var cardViewSliderLayout = "storyCarousel-module--card-view-slider-layout--05b60";
export var chevronButton = "storyCarousel-module--chevron-button--a5caf";
export var content = "storyCarousel-module--content--a9471";
export var eyebrow = "storyCarousel-module--eyebrow--31d05";
export var headline = "storyCarousel-module--headline--6a4ab";
export var headlineContainer = "storyCarousel-module--headline-container--3df6e";
export var segmentIndicatorContainer = "storyCarousel-module--segment-indicator-container--37e65";
export var sliderContainer = "storyCarousel-module--slider-container--826a5";
export var storyCarousel = "storyCarousel-module--story-carousel--bfc13";
export var yearPill = "storyCarousel-module--year-pill--5ccf7";
export var yearPillList = "storyCarousel-module--year-pill-list--f5faf";
export var yearSlide = "storyCarousel-module--year-slide--44f51";
export var yearViewNextArrowButtonContainer = "storyCarousel-module--year-view-next-arrow-button-container--e4f06";
export var yearViewPreviousArrowButtonContainer = "storyCarousel-module--year-view-previous-arrow-button-container--96a76";
export var yearViewSliderLayout = "storyCarousel-module--year-view-slider-layout--a480e";